import React from 'react';

// Returns a local YYYY-MM-DD string (avoids the UTC shift of toISOString()).
const toInputDate = (date) => {
  const offset = date.getTimezoneOffset();
  return new Date(date.getTime() - offset * 60000).toISOString().slice(0, 10);
};

export const DATE_PRESETS = [
  { value: '', label: 'Сите датуми' },
  { value: 'today', label: 'Денес' },
  { value: 'yesterday', label: 'Вчера' },
  { value: 'last7', label: 'Последни 7 дена' },
  { value: 'lastMonth', label: 'Последен месец' },
  { value: 'custom', label: 'Прилагоден' },
];

// Resolves a preset into { dateFrom, dateTo } as YYYY-MM-DD strings.
export function resolvePreset(preset) {
  const today = new Date();

  switch (preset) {
    case 'today':
      return { dateFrom: toInputDate(today), dateTo: toInputDate(today) };
    case 'yesterday': {
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      return { dateFrom: toInputDate(yesterday), dateTo: toInputDate(yesterday) };
    }
    case 'last7': {
      const from = new Date(today);
      from.setDate(from.getDate() - 6); // inclusive of today
      return { dateFrom: toInputDate(from), dateTo: toInputDate(today) };
    }
    case 'lastMonth': {
      const from = new Date(today);
      from.setMonth(from.getMonth() - 1);
      return { dateFrom: toInputDate(from), dateTo: toInputDate(today) };
    }
    default:
      return { dateFrom: '', dateTo: '' };
  }
}

export default function DateRangeFilter({
  preset,
  setPreset,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
}) {
  const handlePresetChange = (value) => {
    setPreset(value);
    if (value !== 'custom') {
      const { dateFrom: from, dateTo: to } = resolvePreset(value);
      setDateFrom(from);
      setDateTo(to);
    }
  };

  const inputClass =
    'w-full px-3 py-1.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm';

  return (
    <div>
      <label className="block text-xs font-medium text-gray-700 mb-1">Период</label>
      <select
        value={preset}
        onChange={(e) => handlePresetChange(e.target.value)}
        className={`${inputClass} bg-white`}
      >
        {DATE_PRESETS.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>

      {preset === 'custom' && (
        <div className="flex gap-2 mt-2">
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            title="Од датум"
            className={inputClass}
          />
          <input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            title="До датум"
            className={inputClass}
          />
        </div>
      )}
    </div>
  );
}
